"use client";

import React from "react";
import "./StructuredDesignSection.scss";
import Image from "next/image";
import { Container } from "react-bootstrap";

const StructuredDesignSection = ({ structuredDesignData }) => {
  const { title, description, image, cards = [] } = structuredDesignData;

  return (
    <section className="structured-design-section">
      <Container className="structured-design-container">
        {/* TOP */}
        <div className="structured-design-top">
          <h2>
            {title.split("\n").map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </h2>

          <p>{description}</p>
        </div>

        {/* CONTENT */}
        <div className="structured-design-content">
          <div className="cards-grid">
            {cards.map((card, index) => (
              <div className="design-card" key={index}>
                <div className="icon-wrapper">
                  <img src={card.icon.src} alt={card.title} />
                </div>

                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            ))}
          </div>

          <div className="image-placeholder">
            <Image
              src={image}
              alt="Structured Design Illustration"
              fill
              className="structured-image"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default StructuredDesignSection;
